import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Navbar from './components/Navbar';
import PrivacyPolicy from './PrivacyPolicy';
import RegisterForm from './components/RegisterForm';
import AccountDeletionPage from './components/AccountDeletionPage'; // Javított import útvonal

function App() {
  return (
    <Router>
      <Navbar />
      <Routes>
        <Route
          path="/"
          element={
            <main style={{ padding: '2rem', fontFamily: 'Arial, sans-serif' }}>
              <h1>Üdvözlünk az Archery Nexus oldalán!</h1>
              <p>
                Itt találod az íjász közösség legfrissebb híreit, versenyeit és információit.
              </p>
              <p>
                Az oldal fejlesztés alatt áll – hamarosan még több tartalommal jelentkezünk!
              </p>
            </main>
          }
        />
        <Route path="/adatvedelem" element={<PrivacyPolicy />} />
        <Route path="/regisztracio" element={<RegisterForm />} />
        <Route path="/fioktorles" element={<AccountDeletionPage />} /> {/* Új útvonal */}
      </Routes>
    </Router>
  );
}

export default App;
